var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.999,
    height: 26,
    viewBox: "0 0 25.999 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(0.994 1.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(-0.993 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M9.785,187.765l-3.064,3.064a3.25,3.25,0,0,1-4.6-4.6l6.128-6.128a3.249,3.249,0,0,1,4.6,0,1.083,1.083,0,0,0,1.532-1.532,5.416,5.416,0,0,0-7.659,0L.593,184.7a5.416,5.416,0,0,0,7.661,7.659l3.064-3.064a1.083,1.083,0,1,0-1.532-1.532Z",
    transform: "translate(0.993 -167.948)",
    fill: "#3b56a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M204.653.586a5.417,5.417,0,0,0-7.661,0l-3.676,3.676a1.083,1.083,0,1,0,1.532,1.532l3.676-3.676a3.25,3.25,0,0,1,4.6,4.6l-6.741,6.741a3.249,3.249,0,0,1-4.6,0,1.083,1.083,0,1,0-1.532,1.532,5.416,5.416,0,0,0,7.659,0l6.741-6.741A5.416,5.416,0,0,0,204.653.586Z",
    transform: "translate(-180.24 1)",
    fill: "#3b56a7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7d69e57f35928272c115639062068d0c.svg";
export { ForwardRef as ReactComponent };